import { Component, OnInit, HostListener } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { UserService } from '../../services/user.service';
import { Key } from 'ts-keycode-enum';
import { DatasService } from 'src/app/services/datas.service';
import { environment } from 'src/environments/environment';
import { MagentoService } from 'src/app/services/magento.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpHeaders } from '@angular/common/http';
import { GTM } from 'src/app/services/gtm.service';
import { MAGENTO_MESSAGES } from 'src/app/enum/magento-messages';

@Component({
  selector: 'ng-hbm-bdi-search-customer',
  templateUrl: './search-customer.component.html'
})
export class SearchCustomerComponent implements OnInit {

  public inputs: any;
  public alreadyTryRenewToken: boolean;
  public isLoading: boolean;
  public searchResults: any;
  public requestError: string;
  public customerSelected: boolean = false;

  constructor(public modal: ModalService,
    public userService: UserService,
    public datas: DatasService,
    public magentoService: MagentoService,
    private translateService: TranslateService,
    private gtm: GTM) {
    this.inputs = {
      email: "",
      customerId: "",
      storeId: userService.userDatas.storeId,
    };
  }

  ngOnInit(): void {
    this.gtm.trackEvent('click', 'search-customer', 'open');
  }

  close() {
    this.gtm.trackEvent('click', 'search-customer', 'close');
    this.modal.close();
  }

  search() {
    this.gtm.trackEvent('click', 'search-customer', 'search');
    this.requestError = "";
    this.isLoading = true;
    let headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("country", this.userService.country);

    let _searchCustomersParam: any = {
      method: "GET",
      url: environment.backEnd.baseApi + "Customer?email=" + this.inputs.email,
      headers: headers
    };

    this.datas.generateBackendApiRequest(_searchCustomersParam).subscribe((jsonResponse: any) => {
      this.searchResults = jsonResponse;
      for (let customer of this.searchResults) {
        if (customer.typeData === "vendor") {
          customer.hbmId = customer.hbmUserId;
        } else {
          customer.hbmId = customer.customerAttributes?.hbmUserId?.value;
        }        
      }
      this.requestError = (this.searchResults.length > 0) ? "" : this.translateService.instant('popins.search_customer.no_result');
      this.isLoading = false;

    }, (err: any) => {
      console.error(err);
      if (err.status === 401 && !this.alreadyTryRenewToken) {
        this.alreadyTryRenewToken = true;
        this.search();
      } else if (err.status === 401 && this.alreadyTryRenewToken) {
        this.isLoading = false;
        this.searchResults = [];
        this.requestError = this.translateService.instant('popins.search_customer.invalid_session');
      } else if (err.status === 400) {
        this.requestError = "<h3>" + this.translateService.instant('popins.search_customer.invalid_request') + "</h3>";
        this.requestError += "<ul><li>" + this.translateService.instant('popins.search_customer.invalid_request_reason1') + "</li></ul>";
        this.isLoading = false;
        this.searchResults = [];
      } else {
        this.isLoading = false;
        this.searchResults = [];
        this.requestError = this.translateService.instant('popins.search_customer.error_api');
      }
    });
  }

  selectCustomer(customer: any) {
    let phone = this.getPhone(customer);
    this.gtm.trackEvent('click', 'search-customer', 'select');
    if (!customer.hbmId) { //cas le compte n'a pas d'id hbm, il faut le créer et se connecter
      this.userService.byMeServiceRef.createUser(true).then(hbmUserId => {
        //ensuite on récupère un nouveau token et on se connecte
        this.userService.byMeServiceRef.acquireToken(hbmUserId, true).then(() => {
          // On envoie le hbm user id à Magento.
          this.magentoService.postMessageToMagento(
            MAGENTO_MESSAGES.MATCH_ACCOUNT,
            { 
              hbm_user_id: hbmUserId, 
              magento_id: customer.typeData === 'vendor'? customer.userId : customer.id,
              role:  customer.typeData === 'vendor' ? 'vendor' : 'customer'
            }
          );

          if (this.modal.currentDatas.onCustomerSelect) {
            this.modal.currentDatas.onCustomerSelect(
              hbmUserId, 
              customer.typeData === 'vendor'? customer.userId : customer.id, 
              this.getCompleteName(customer), 
              phone,
              customer.email);
          }
        })
      });
    } else {
      this.userService.byMeServiceRef.acquireToken(customer.hbmId, true).then(() => {
        if (this.modal.currentDatas.onCustomerSelect) {
          this.modal.currentDatas.onCustomerSelect(customer.hbmId,
            customer.typeData === 'vendor'? customer.userId : customer.id,
            this.getCompleteName(customer),
            phone,
            customer.email);
        }
      });
    }
  }

  getPhone(customer: any): string {
    if (customer.addresses?.length > 0) {
      return customer.addresses[0].telephone;
    }
    return null;
  }

  getCompleteName(customer: any): string {
    return `${customer.lastname != undefined ? customer.lastname : ""}${customer.middlename != undefined ? ` ${customer.middlename}` : ""} ${customer.firstname != undefined ? customer.firstname : ""}`.trim();
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {

    if (event.which === Key.Enter) {
      this.search();
    }
  }
}
